import { Injectable } from '@angular/core';
import {
  injectMutation,
  injectQuery,
  QueryKey,
} from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';
import { BaseApiService } from './base.api.service';
import { News } from '../models/news.model';

@Injectable({ providedIn: 'root' })
export class NewsService extends BaseApiService {
  private myNews: QueryKey = ['myNews'];

  getListNews() {
    return injectQuery(() => ({
      queryKey: this.myNews,
      queryFn: async () => {
        try {
          return await lastValueFrom(
            this.httpClient.get<News[]>(`${this.baseUrl}/api/news/news`, {
              withCredentials: true,
            })
          );
        } catch (error: any) {
          this.handleError(error);
          throw error;
        }
      },
    }));
  }

  /** Recherche des news par titre */
  searchByTitle = injectMutation(() => ({
    retry: false,
    mutationFn: async (args: { titre: string }) => {
      try {
        return await lastValueFrom(
          this.httpClient.post<News[]>(
            `${this.baseUrl}/api/news/news/searchByTitle`,
            { titre: args.titre },
            { withCredentials: true }
          )
        );
      } catch (error: any) {
        this.handleError(error);
        throw error;
      }
    },
  }));

  getNewsByIds = injectMutation(() => ({
    retry: false,
    mutationFn: async (ids: string[]) => {
      try {
        return await lastValueFrom(
          this.httpClient.post<News[]>(
            `${this.baseUrl}/api/news/news/listByIds`,
            ids,
            {
              withCredentials: true,
            }
          )
        );
      } catch (error: any) {
        this.handleError(error);
        throw error;
      }
    },
  }));
}
